import { Table } from 'react-bootstrap';
import Row from './csv-table-row';

const CsvTable = ({ data = [], handleListChange }) => (
  <Table bordered hover striped size="sm">
    <thead>
      <tr>
        <th>
          #
        </th>
        <th>
          File name
        </th>
      </tr>
    </thead>
    <tbody>
      {data.map((value, key) => <Row filename={value} handleListChange={handleListChange} key={key} />)}
    </tbody>
  </Table>
);

export default CsvTable;
